
import createUserFavProductMutation from '@/apollo/mutations/user/createUserFavProductMutation';
import deleteUserFavProductMutation from '@/apollo/mutations/user/deleteUserFavProductMutation';
import userFavProductQuery from '@/apollo/queries/user/userFavProductQueryWithLogin';
import eventTrackingMixins from '~/mixins/eventTrackingMixins.js';

export default {
  name: 'ToggleFavouriteProduct',

  mixins: [eventTrackingMixins],

  props: {
    size: {
      type: String,
      default: 'small',
    },
    scenarioId: String,
    params: String,
    propFavProductId: String,
    productType: {
      type: String,
      default: '',
    },
  },

  data() {
    return {
      isFavourite: false,
      disableHover: false,
      favProductId: this.propFavProductId,
    };
  },
  apollo: {
    favProduct: {
      prefetch: true,
      fetchPolicy: 'no-cache',
      query: userFavProductQuery,
      variables() {
        const returnObj = {};
        return returnObj;
      },
      context() {
        let contextObj = {};
        const authToken = localStorage.getItem('apollo_token')
        contextObj = {
          headers: {
            Authorization: `Bearer ${authToken}`,
          }
        }
        return contextObj;
      },
      update(data) {
        // if(data?.userFavProducts?.data?.length > 0){
        //   this.isFavourite=true;
        //   this.favProductId=data?.userFavProducts?.data[0].id;
        // }
        return this.$normalizeStrapi(data?.me?.FavProducts?.data);
      },
      result({ data }) {
        // console.debug(JSON.stringify(data));
        if (data?.me?.FavProducts?.data) {
          const products = this.$normalizeStrapi(data?.me?.FavProducts?.data);
          // console.debug("query finish, checkIsFav");
          this.checkIsFav(products);
        }
      },
      skip() {
        if (this.propFavProductId || !this.$store.state.auth.loggedIn) console.debug('skipped query');
        return this.propFavProductId || !this.$store.state.auth.loggedIn;
      },
    },
  },

  watch: {
    scenarioId(newVal) {
      // console.debug('newval for scenarioId: ' + newVal);
      // console.debug("new scenarioId for the card, checkIsFav");
      this.checkIsFav(this.favProduct);
    },
  },

  mounted() {
    if (this.propFavProductId) {
      // console.debug('is fav, id: ' + this.propFavProductId);
      this.favProductId = this.propFavProductId;
      this.isFavourite = true;
    } else {
      // this.isFavourite = false;
      // check store 
      const myfavPendingProducts = this.$store.getters['myfav/myfavPendingProducts'];
      // console.debug(myfavPendingProducts);
      if(myfavPendingProducts.length>0)
      {
        if (this.$store.state.auth.loggedIn) {
          if(myfavPendingProducts === this.scenarioId+"_"+this.getTypename())
          {
            // console.debug("is pending, now toggleFav");
            // console.debug(this.scenarioId+"_"+this.getTypename());
            this.toggleFavouriteProduct();
            this.$store.commit('myfav/removeAllMyFavPendingProducts');
          }
        }
        else
        {
          this.$store.commit('myfav/removeAllMyFavPendingProducts');
        }
      }
    }
  },

  updated() {
    if (this.propFavProductId) {
      // console.debug('is fav, id: ' + this.propFavProductId);
      this.favProductId = this.propFavProductId;
      this.isFavourite = true;
    } else {
      // this.isFavourite = false;
      // check store 
      const myfavPendingProducts = this.$store.getters['myfav/myfavPendingProducts'];
      // console.debug(myfavPendingProducts);
      if(myfavPendingProducts.length>0)
      {
        if (this.$store.state.auth.loggedIn) {
          if(myfavPendingProducts === this.scenarioId+"_"+this.getTypename())
          {
            // console.debug("is pending, now toggleFav");
            // console.debug(this.scenarioId+"_"+this.getTypename());
            this.toggleFavouriteProduct();
            this.$store.commit('myfav/removeAllMyFavPendingProducts');
          }
        }
        else
        {
          this.$store.commit('myfav/removeAllMyFavPendingProducts');
        }
      }
    }
  },

  methods: {
    async toggleFavouriteProduct(event) {
      if (this.$store.state.auth.loggedIn) {
        this.isFavourite = !this.isFavourite;
        if (this.isFavourite) {
          // console.debug("adding new my fav product")
          // console.debug({"scenarioId": this.scenarioId, "productType": this.getTypename(), "favProductId": this.favProductId});
          this.$store.commit('myfav/setMyfavNewProducts', {"scenarioId": this.scenarioId, "productType": this.getTypename(), "favProductId": this.favProductId});

          this.disableHover = true;

          const userId = this.$store.state.auth.user.id;

          const scenarioId = parseInt(this.scenarioId);

          // console.debug('this.scenarioId:' + this.scenarioId);
          // console.debug('this.productType:' + this.productType);

          const params = this.getParams();
          const typeName = this.getTypename();

          const vars = {
            data: {
              User: userId,
              Params: params,
              ProductType: typeName,
              ProductScenarioId: scenarioId,
              // "Product": [
              //   {
              //     "__typename": typeName,
              //     "Product": scenarioId,
              //   }
              // ]
            },
          };

          // console.debug(vars);

          const authToken = localStorage.getItem('apollo_token');

          await this.$apollo
            .mutate({
              mutation: createUserFavProductMutation,
              variables: vars,
              context: {
                headers: {
                  Authorization: `Bearer ${authToken}`,
                }
              }
            })
            .then((apolloRes) => {
              const data = this.$normalizeStrapi(apolloRes.data.createUserFavProduct.data);
              this.favProductId = data.id;
              console.debug(JSON.stringify(data));
              // console.debug("is fav?: "+ this.isFavourite);

              this.$store.commit('myfav/removeAllMyFavNewProducts');
              
              this.handleEventTracking_saveProduct(event, {id: data.id});

              const url = location.href;
              const pageInfo = this.getCurrentPageInfo(url)

            });
        } else {
          console.debug('unfav: ' + this.favProductId);
          // this.$emit('unfavourite', this.favProductId);

          const authToken = localStorage.getItem('apollo_token');

          const apolloRes = await this.$apollo
            .mutate({
              mutation: deleteUserFavProductMutation,
              variables: {
                id: this.favProductId,
              },
              context: {
                headers: {
                  Authorization: `Bearer ${authToken}`,
                }
              }
            })
            .then((apolloRes) => {
              this.$emit('unfavourite', this.favProductId);
            });
        }
      } else {
        // save myfav product before redirect to login
        // console.log({"scenarioId": this.scenarioId, "productType": this.getTypename()});
        this.$store.commit('myfav/setMyfavPendingProducts', this.scenarioId+"_"+this.getTypename());

        // this.$store.commit('modal/setShowLoginModal', true);
        this.$store.commit('modal/setLoginModalEntryPoint', 'my_save_page_popup');
        this.$auth.loginWith('tenlife');
      }
    },

    getTypename() {
      let typeName = '';
      let inputType = '';
      if (this.productType.length > 0) {
        inputType = this.productType;
      } else {
        inputType = this.$route.path;
      }

      if (inputType.includes('medical')) {
        typeName = 'ComponentUserMedical';
      }
      if (inputType.includes('term-critical-illness')) {
        typeName = 'ComponentUserTermCi';
      }
      if (inputType.includes('annuity')) {
        typeName = 'ComponentUserAnnuity';
      }
      if (inputType.includes('long-term-savings')) {
        typeName = 'ComponentUserSaving';
      }
      if (inputType.includes('short-term-savings')) {
        typeName = 'ComponentUserShortTermSaving';
      }
      if (inputType.includes('term-cancer')) {
        typeName = 'ComponentUserTermCancer';
      }
      if (inputType.includes('term-life')) {
        typeName = 'ComponentUserTermLife';
      }
      if (inputType.includes('whole-life-critical-illness')) {
        typeName = 'ComponentUserWlci';
      }
      if (inputType.includes('whole-life-protection')) {
        typeName = 'ComponentUserWlProtection';
      }
      if (inputType.includes('home')) {
        typeName = 'ComponentUserHome';
      }
      if (inputType.includes('travel')) {
        typeName = 'ComponentUserTravel';
      }
      if (inputType.includes('personal-accident')) {
        typeName = 'ComponentUserPersonalAccident';
      }
      return typeName;
    },

    getParams() {
      // console.debug(this.params);
      const productLink = this.params ? this.params : this.$route.fullPath;
      // console.debug(productLink);
      let params = '';

      if (productLink.includes('deferred-annuity')) {
        if (productLink.includes('savings')) {
          params = 'objective=savings';
        }
        if (productLink.includes('stable_retirement_income')) {
          params = 'objective=stable_retirement_income';
        }
        if (productLink.includes('growth_retirement_income')) {
          params = 'objective=growth_retirement_income';
        }
        if (productLink.includes('longevity')) {
          params = 'objective=longevity';
        }
      } else if (productLink.includes('immediate-annuity')) {
        params = 'objective=immediate_annuity';
      }
      else {
        const splittedParts = productLink.split('?');
        params = splittedParts.length > 1 ? splittedParts[1] : '';
      }

      return params;
    },

    makeDisableHover() {
      this.disableHover = false;
    },

    checkIsFav(products) {
      // console.debug('fav product list:');
      // console.debug(products);
      // console.debug('finding');
      // console.debug(this.scenarioId);
      const matchedFavProduct = products?.filter((item) => {
        return (
          item.ProductScenarioId?.toString() === this.scenarioId &&
          item.ProductType === this.getTypename() &&
          item.ProductScenarioId?.toString().length > 0
        );
      });
      // console.debug(matchedFavProduct);
      if (matchedFavProduct?.length > 0) {
        this.isFavourite = true;
        this.favProductId = matchedFavProduct[0].id;
      } else {
        const newProducts = this.$store.getters['myfav/myfavNewProducts'];
        // console.debug(newProducts)
        const foundNewProduct = newProducts.find(({scenarioId, productType}) => scenarioId === this.scenarioId && productType === this.getTypename())
        if(foundNewProduct)
        {
          console.debug("found: "+foundNewProduct.scenarioId)
          this.isFavourite = true;
          this.favProductId = foundNewProduct.favProductId;
          this.$store.commit('myfav/removeAllMyFavNewProducts');
        }
        else
        {
          this.isFavourite = false;
          this.favProductId = 0;
        }
      }
    },
    
    handleEventTracking_saveProduct(event, data) {

      const dataFromClickedElement = this.extractDataFromClickedElement(event.target)
      
      const url = location.href;
      const pageInfo = this.getCurrentPageInfo(url)
      const insuranceCompany = dataFromClickedElement.offsetparent_node.getAttribute("data-insurer-company")
      const productScenarioCode = dataFromClickedElement.offsetparent_node.getAttribute("data-product-id")
      const productName = dataFromClickedElement.offsetparent_node.getAttribute("data-product-name")
      const productCategory = dataFromClickedElement.offsetparent_node.getAttribute("data-product-category")

      const eventTrackingParams = this.initEventTrackingParams()
      
      if (pageInfo.page_type === 'blogSingle') {
        // #98 
        eventTrackingParams.a = 'save_product'
        eventTrackingParams.l =  data?.id
        eventTrackingParams.c = `blog_related_products_card_icon`
        eventTrackingParams.cd.insurer_name = insuranceCompany
        eventTrackingParams.cd.product_name = productName
        eventTrackingParams.cd.product_category = productCategory
      } 
      if (pageInfo.page_type === 'decoder') {
        // #99 
        eventTrackingParams.a = 'save_product'
        eventTrackingParams.l =  data?.id
        eventTrackingParams.c = `decoder_card_icon`
        eventTrackingParams.cd.insurer_name = insuranceCompany
        eventTrackingParams.cd.product_name = productName
        eventTrackingParams.cd.product_category = productCategory
      } 
      if (pageInfo.page_type === 'productDetail') {
        // #100 
        eventTrackingParams.a = 'save_product'
        eventTrackingParams.l =  data?.id
        eventTrackingParams.c = `product_details_icon`
        eventTrackingParams.cd.insurer_name = insuranceCompany
        eventTrackingParams.cd.product_name = productName
        eventTrackingParams.cd.product_category = productCategory
      } 

      this.sendEventTracking(eventTrackingParams)
    }
  },
};
